import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

@Directive({
  selector: '[appSamePasswordValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: SamePasswordValidatorDirective, multi: true}]
})
export class SamePasswordValidatorDirective implements Validator {

  @Input()
  get appSamePasswordValidator() {
    return this._appSamePasswordValidator;
  }

  set appSamePasswordValidator(value: string) {
    this._appSamePasswordValidator = value;
    if (this._onChange) {
      this._onChange();
    }
  }

  private _appSamePasswordValidator: string;
  private _onChange: () => void;

  validate(c: AbstractControl): ValidationErrors | null {
    if (c.value && this.appSamePasswordValidator && c.value !== this.appSamePasswordValidator) {
      return {
        samePasswordValidator: true
      };
    }

    return null;
  }

  registerOnValidatorChange(fn: () => void): void {
    this._onChange = fn;
  }

}
